
  var _styles = {
  "hotel-card__price-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "space-between"
  },
  "hotel-card__price-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "hotel-card__price-symbol": {
    "fontSize": "0.32rem",
    "color": "rgb(255,102,0)",
    "fontWeight": "600",
    "marginRight": "0.05333rem",
    "marginBottom": "0.05333rem"
  },
  "hotel-card__current-price": {
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "fontWeight": "700",
    "lineHeight": "0.64rem",
    "height": "0.66667rem",
    "overflow": "visible"
  },
  "hotel-card__price-label": {
    "fontSize": "0.26667rem",
    "color": "rgb(153,153,153)",
    "marginLeft": "0.10667rem",
    "marginBottom": "0.10667rem"
  },
  "hotel-card__original-price": {
    "fontSize": "0.32rem",
    "color": "rgb(204,204,204)",
    "marginLeft": "0.16rem",
    "marginBottom": "0.10667rem",
    "WebkitTextDecorationLine": "line-through",
    "textDecorationLine": "line-through"
  },
  "hotel-card__book-btn": {
    "borderRadius": "0.53333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.38667rem",
    "height": "0.8rem",
    "backgroundColor": "rgb(255,102,0)",
    "marginLeft": "0.26667rem"
  },
  "hotel-card__book-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem"
  },
  "hotel-card__price-change-container": {
    "flex": 1,
    "display": "flex",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "hotel-card__original-price-comparision": {
    "fontSize": "0.29333rem",
    "marginLeft": "0.16rem",
    "marginBottom": "0.10667rem",
    "fontWeight": "400",
    "color": "rgb(133,134,135)",
    "WebkitTextDecorationLine": "line-through",
    "textDecorationLine": "line-through"
  },
  "hotel-card__recommended-container": {
    "height": "0.76rem",
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "overflow": "visible"
  },
  "hotel-card__price-image": {
    "width": "4.26667rem",
    "position": "relative",
    "top": "0.26667rem",
    "overflow": "visible"
  },
  "hotel-card__recommended-price-container": {
    "position": "relative",
    "top": "-0.16rem",
    "height": "0.66667rem",
    "overflow": "visible"
  }
};



  module.exports = _styles;
  